"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _tracking_utility = require("common-utilities/src/tracking_utility");

var _ramda = require("ramda");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClickOrEscapeOutside = function (_React$Component) {
  _inherits(ClickOrEscapeOutside, _React$Component);

  function ClickOrEscapeOutside(props) {
    _classCallCheck(this, ClickOrEscapeOutside);

    var _this = _possibleConstructorReturn(this, (ClickOrEscapeOutside.__proto__ || Object.getPrototypeOf(ClickOrEscapeOutside)).call(this, props));

    _this.state = {
      openDropdown: false
    };

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleEscKey = _this.handleEscKey.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleOpen = _this.handleOpen.bind(_this);
    _this.trackGAEvent = _this.trackGAEvent.bind(_this);
    _this.containerRef = _react2.default.createRef();
    return _this;
  }

  _createClass(ClickOrEscapeOutside, [{
    key: "handleClose",
    value: function handleClose(e) {
      var _this2 = this;

      if (this.state.openDropdown) {
        this.setState({ openDropdown: false }, function () {
          if (typeof _this2.props.onClose === "function") {
            _this2.props.onClose(e);
          }
        });
      } else if (this.props.isWidgetOpen && !(0, _ramda.isNil)(this.props.tooltipRef) && !(0, _ramda.isNil)(this.props.tooltipRef.state) && this.props.tooltipRef.state.tooltipStyle === 'none') {
        if (typeof this.props.onClose === "function") {
          this.props.onClose(e);
        }
      }
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      this.setState({ openDropdown: true });
      this.trackGAEvent();
    }
  }, {
    key: "trackGAEvent",
    value: function trackGAEvent() {
      if (this.props.id === "dropdownShareclass") {
        _tracking_utility.TrackingUtility.trackEvent({
          "eventCategory": "pdp",
          "eventAction": "shareclass dropdown",
          "eventLabel": 'expand'
        });
      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      document.body.addEventListener('click', this.handleClick);
      document.body.addEventListener('touchend', this.handleClick);
      document.body.addEventListener('keydown', this.handleEscKey);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.handleClick);
      document.body.removeEventListener('touchend', this.handleClick);
      document.body.removeEventListener('keydown', this.handleEscKey);
    }
  }, {
    key: "handleEscKey",
    value: function handleEscKey(event) {
      var keyCode = event.keyCode;
      if (keyCode === 27) {
        this.handleClose(event);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      if (event.target !== this.containerRef.current && !this.containerRef.current.contains(event.target)) {
        this.handleClose(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { id: "" + (this.props.id ? this.props.id : "parentContainer"),
          className: "" + this.props.additionalClassName,
          ref: this.containerRef },
        _react2.default.cloneElement(this.props.children, {
          onShowDropdown: this.handleOpen,
          onHideDropdown: this.handleClose,
          openDropdown: this.state.openDropdown
        })
      );
    }
  }]);

  return ClickOrEscapeOutside;
}(_react2.default.Component);

exports.default = ClickOrEscapeOutside;